import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CadastroPerguntasService {
    public nomeProduto = new BehaviorSubject<string>(null);
    public nomePergunta = new BehaviorSubject<string>(null);
    public codigoProduto = new BehaviorSubject<number>(0);
    public codigoFamilia = new BehaviorSubject<number>(0);

    constructor() { }
}
